import { jsx as _jsx } from "react/jsx-runtime";
import { buildClassName } from '@bluebeam/build-class-name';
import { forwardRef } from 'react';
const borderClass = {
    destructive: 'border-alerts-error-red border-[1px] border-solid disabled:border-alerts-error-red/20',
    filled: 'border-primary-blue border-[1px] border-solid hover:border-transparent disabled:border-transparent',
    outline: 'border-primary-blue border-[1px] border-solid disabled:border-primary-blue/20',
    text: 'border-none',
};
const backGroundClass = {
    destructive: 'hover:bg-alerts-error-red/10 bg-white disabled:hover:bg-white',
    filled: 'bg-primary-blue hover:bg-primary-blue/75 disabled:bg-[#689FD0]',
    outline: 'hover:bg-primary-blue/10 bg-white disabled:bg-white',
    text: 'bg-transparent',
};
const textClass = {
    destructive: 'text-alerts-error-red disabled:text-alerts-error-red/20',
    filled: 'text-white disabled:text-[#84B0DA]',
    outline: 'text-primary-blue disabled:text-primary-blue/20',
    text: 'text-primary-blue hover:underline disabled:text-black/20 disabled:no-underline',
    '32px': 'skyline-text-button-2 min-h-[32px]',
    '40px': 'skyline-text-button-1 min-h-[40px]',
};
/**
 * Buttons are a type of **atom** that represent a `<button>` element.
 */
const Button = forwardRef(({ className, size = '32px', type = 'button', variant = 'filled', ...rest }, ref) => {
    return (_jsx("button", { className: buildClassName('inline-flex cursor-pointer items-center rounded-lg px-6 font-medium disabled:cursor-default', 'focus-visible:outline-primary-blue focus-visible:outline focus-visible:outline-2 focus-visible:outline-offset-2', `${borderClass[variant]} ${backGroundClass[variant]} ${textClass[variant]} ${textClass[size]}`, className), ref: ref, type: type, ...rest }));
});
export default Button;
//# sourceMappingURL=Button.js.map